import { useState, useEffect } from 'react'

export function useCountdown(initialMinutes: number = 15) {
  const [timeLeft, setTimeLeft] = useState({
    minutes: initialMinutes,
    seconds: 0,
  })
  const [isUrgent, setIsUrgent] = useState(false)

  useEffect(() => {
    const storageKey = `fisica_countdown_end_${initialMinutes}m`
    const savedEndTime = localStorage.getItem(storageKey)
    let endTime: number

    if (savedEndTime) {
      endTime = parseInt(savedEndTime, 10)
      if (endTime < Date.now()) {
        endTime = Date.now() + initialMinutes * 60 * 1000
        localStorage.setItem(storageKey, endTime.toString())
      }
    } else {
      endTime = Date.now() + initialMinutes * 60 * 1000
      localStorage.setItem(storageKey, endTime.toString())
    }

    const calculateTimeLeft = () => {
      const difference = endTime - Date.now()

      if (difference > 0) {
        const mins = Math.floor((difference / 1000 / 60) % 60)
        const secs = Math.floor((difference / 1000) % 60)
        setTimeLeft({ minutes: mins, seconds: secs })
        setIsUrgent(difference <= 10 * 60 * 1000)
      } else {
        setTimeLeft({ minutes: 0, seconds: 0 })
        setIsUrgent(true)
      }
    }

    calculateTimeLeft()
    const timer = setInterval(calculateTimeLeft, 1000)

    return () => clearInterval(timer)
  }, [initialMinutes])

  return { ...timeLeft, isUrgent }
}
